import React, { Component } from 'react'

import { TopLevelFallbackError } from './TopLevelFallbackError'

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static defaultProps = {
    ErrorComponent: TopLevelFallbackError,
    fallbackErrorMessage: "ErrorBoundary caught error in top-level component",
    context: {}
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureMessage(errorInfo || this.props.fallbackErrorMessage)
    Sentry.captureException(error, this.props.context)
  }

  render() {
    if (this.state.hasError) {
      const { ErrorComponent } = this.props
      return <ErrorComponent error={this.state.error}/>
    }

    return this.props.children
  }
}
